import React from 'react';
import Wrapper from '../layout/Wrapper';

export default function Error() {
  return (
    <Wrapper
      testID="error-page"
      errorAlert
      pageTitle="Schedule a call with VA Solid Start"
    />
  );
}
